export default "__VITE_ASSET__C_JF73$b__"